import MaterialUI from "material-UI";
import { MdErrorOutline, MdCheckCircleOutline } from "react-icons/md";
import * as S from "./styles";

type ItemValidacao = {
  titulo: string;
  aprovado: boolean;
  mensagem: string;
};

interface Props {
  dataValidarProposta: any;
  isLoadingValidarProposta: boolean;
}

// A ordem segue a mesma sequência dos campos no Resumo de Pagamento.
const CAMPOS: { chave: string; variante: S.Variante }[] = [
  { chave: "formaPagamento", variante: "atencao" },
  { chave: "desconto", variante: "reprovado" },
  { chave: "proSoluto", variante: "reprovado" },
  { chave: "anual", variante: "reprovado" },
  { chave: "comprometimentoPico", variante: "reprovado" },
  { chave: "enquadramento", variante: "reprovado" },
  { chave: "normativaUmDorm", variante: "reprovado" },
];

// Forma de pagamento personalizada não é erro (não reprova a proposta), mas
// também não é "ok": fica em amarelo para o usuário notar que fugiu do padrão.
// Por isso este campo é colorido pelo valor, não pelo `aprovado`.
function ehFormaPagamentoPersonalizada(mensagem?: string) {
  return (mensagem ?? "").trim().toLowerCase().startsWith("personalizada");
}

export default function ValidacaoProposta(props: Readonly<Props>) {
  const data = props.dataValidarProposta?.data;

  const itens = CAMPOS.map(({ chave, variante }) => {
    const item: ItemValidacao = data?.[chave];
    if (!item) return null;

    const personalizada =
      chave === "formaPagamento" &&
      ehFormaPagamentoPersonalizada(item.mensagem);

    return {
      chave,
      titulo: item.titulo,
      mensagem: item.mensagem,
      variante: item.aprovado && !personalizada ? "aprovado" : variante,
    };
  }).filter(Boolean) as {
    chave: string;
    titulo: string;
    mensagem: string;
    variante: S.Variante;
  }[];

  const statusAprovado = CAMPOS.every(
    ({ chave }) => data?.[chave]?.aprovado !== false
  );

  return (
    <S.Container>
      <S.Row>
        <S.Title>Validação da Proposta</S.Title>
        {props.isLoadingValidarProposta && (
          <MaterialUI.CircularProgress style={{ color: "blue" }} size={22} />
        )}
      </S.Row>
      <S.BodyContainer>
        {itens.length === 0 ? (
          <S.EmptyMessage>
            {props.isLoadingValidarProposta
              ? "Validando a proposta..."
              : "A validação será exibida após o cálculo da proposta."}
          </S.EmptyMessage>
        ) : (
          <>
            {itens.map((item) => (
              <S.ItemRow key={item.chave}>
                <S.ItemLabel>{item.titulo}</S.ItemLabel>
                <S.ItemValue variante={item.variante}>
                  {item.variante === "aprovado" ? (
                    <MdCheckCircleOutline size={16} />
                  ) : (
                    <MdErrorOutline size={16} />
                  )}
                  {item.mensagem}
                </S.ItemValue>
              </S.ItemRow>
            ))}
            {data?.statusGeral ? (
              <S.ItemRow>
                <S.ItemLabel destaque>Status</S.ItemLabel>
                <S.ItemValue
                  destaque
                  variante={statusAprovado ? "aprovado" : "reprovado"}
                >
                  {data.statusGeral}
                </S.ItemValue>
              </S.ItemRow>
            ) : null}
          </>
        )}
      </S.BodyContainer>
    </S.Container>
  );
}
